import slideoverControls from 'views/assets/scripts/slideoverControls'
import mountOffCanvasContainer from 'views/containers/browser/OffCanvasContainer/mountOffCanvasContainer'

export default () => {
  const slideover = slideoverControls()
  mountOffCanvasContainer(slideover.show)
}
